/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { initMercadoPago } from "@mercadopago/sdk-react";
import { myHeaders } from "../../config/axios";
import { URL_API } from "../../config/default";
import { selectPrice, total } from "../../utils/details";
//import mercadoPago from "../../assets/img/mercado-pago.png";
import { MessageCircle, Loader2 } from "lucide-react";
import { Button } from "../../components/UI/Button";
import { CustomToast } from "../../utils/custom-toast";

const Checkout = ({ reserva, user }: any) => {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    initMercadoPago(
      "APP_USR-4c86c5d2-49e6-4671-adbb-f504cb894190",
      /*"TEST-7a20ab93-fce1-4fa7-a3ac-0cbe6d665842"*/ {
        locale: "es-AR",
      }
    );
  }, []);

  /*
  const payment = () => {
    const formdata = new FormData();

    const totalTax = total({
      ...reserva.property,
      price:
        selectPrice(
          reserva.property.price,
          reserva.property.prices,
          reserva.guests
        ) * reserva.differenceDay,
    });

    let totalService = 0.0;
    reserva.property.fees.map((fee: any) => {
      totalService = totalService + parseFloat(fee.price);
    });

    formdata.append("title", reserva.title);
    formdata.append("firstname", user.firstname);
    formdata.append("lastname", user.lastname);
    formdata.append("start_date", reserva.start_date);
    formdata.append("tax", "0");
    formdata.append("services", String(totalService));
    formdata.append("quantity", "1");
    formdata.append(
      "price",
      selectPrice(
        reserva.property.price,
        reserva.property.prices,
        reserva.guests
      )
    );
    formdata.append("total", String(totalTax));
    formdata.append("type", reserva.type);

    if (reserva.excursion) {
      formdata.append("guests", String(1));
      formdata.append("end_date", reserva.start_date);
      formdata.append("excursion_id", reserva.property.id);
    } else {
      formdata.append("guests", reserva.guests);
      formdata.append("end_date", reserva.end_date);
      formdata.append("checkin", reserva.checkin);
      formdata.append("checkout", reserva.checkout);
      formdata.append("property_id", reserva.property.id);
    }

    const requestOptions = {
      method: "POST",
      body: formdata,
      headers: {
        Authorization: myHeaders, // Un ejemplo de header de autenticación
      },
    };
    fetch(`${URL_API}/checkout`, requestOptions)
      .then(async (res) => {
        const response = await res.json();

        return (window.location.href = response.data.init_point);
      })
      .then((result) => console.log(result))
      .catch((error) => console.error(error));
  };*/

  const prePayment = () => {
    setIsLoading(true);
    const formdata = new FormData();

    const totalTax = total({
      ...reserva.property,
      price:
        selectPrice(
          reserva.property.price,
          reserva?.property?.prices ?? [],
          reserva.guests
        ) * reserva.differenceDay,
    });

    let totalService = 0.0;
    reserva.property.fees.map((fee: any) => {
      totalService = totalService + parseFloat(fee.price);
    });

    formdata.append("status", "pre-pending");
    formdata.append("title", reserva.title);
    formdata.append("firstname", user.firstname);
    formdata.append("lastname", user.lastname);
    formdata.append("start_date", reserva.start_date);
    formdata.append("end_date", reserva.end_date);
    formdata.append("tax", "0");
    formdata.append("services", String(totalService));
    formdata.append("quantity", "1");
    formdata.append(
      "price",
      selectPrice(
        reserva.property.price,
        reserva.property.prices,
        reserva.guests
      )
    );
    formdata.append("total", String(totalTax));
    formdata.append("type", reserva.type);

    if (reserva.excursion) {
      formdata.append("guests", String(1));
      formdata.append("checkin", reserva.start_date);
      formdata.append("checkout", reserva.end_date);
      formdata.append("excursion_id", reserva.property.id);
    } else {
      formdata.append("guests", reserva.guests);
      formdata.append("checkin", reserva.checkin);
      formdata.append("checkout", reserva.checkout);
      formdata.append("property_id", reserva.property.id);
    }

    const requestOptions = {
      method: "POST",
      body: formdata,
      headers: {
        Authorization: myHeaders, // Un ejemplo de header de autenticación
      },
    };
    fetch(`${URL_API}/checkout`, requestOptions)
      .then(async (res) => {
        const response = await res.json();

        if (response.success) {
          CustomToast({
            status: 'success',
            title: "Consulta enviada al Anfitrión",
            msg: "Espera su respuesta por mail o revisando los mensajes en la web"
          })
          setTimeout(() => {
            return (window.location.href = "/chat");
          }, 2000)
        } else {
          CustomToast({
            status: 400,
            title: "Ocurrio un error con su consulta",
            msg: "Vuelva a intentarlo mas tarde"
          })
          setIsLoading(false);
        }
      })
      .then((result) => console.log(result))
      .catch((error) => {
        console.error(error);
        setIsLoading(false);
      });
  };


  return (
    <div className="w-full my-3">
      <Button
        variant="outline"
        onClick={() => prePayment()}
        disabled={isLoading}
        className="w-full border-[#8B9456] text-[#8B9456] hover:bg-[#8B9456] hover:text-white font-semibold py-5 bg-transparent mb-2 text-wrap lg:text-nowrap"
        style={{ borderRadius: "10px" }}
      >
        {isLoading ? (
          <>
            <Loader2 className="w-5 h-5 mr-2 animate-spin" />
            <span>Enviando mensaje...</span>
          </>
        ) : (
          <>
            <MessageCircle className="w-5 h-5 mr-2" />
            <span>Enviar mensaje al anfitrion para reservar</span>
          </>
        )}
      </Button>

      {/* 
      <Button
        onClick={() => payment()}
        className=" w-full bg-[#00B1EA] hover:bg-[#0099CC] text-white font-semibold flex items-center justify-center gap-2 py-6"
      >
        <img src={mercadoPago} className="w-[50px] me-2" alt="" />
        Pagar con mercado pago
      </Button>
      */}
    </div>
  );
};

export default Checkout;
